import nextId from 'react-id-generator';
import { useState } from 'react';

export default function TextInput({
  label,
  name,
  value,
  onChange,
  requireValue,
  validator = null,
}) {
  const htmlId = nextId();
  const [isValid, setIsValid] = useState(checkValid(value));

  const handleChange = (event) => {
    const valid = checkValid(event.target.value);
    setIsValid(valid);
    onChange(event, valid);
  };

  function checkValid(value) {
    if (!requireValue) return true;
    if (validator) return validator(value);
    return value !== '';
  }

  return (
    <div>
      <label
        htmlFor={htmlId}
        className="block text-sm font-medium text-gray-700 sm:mt-px pt-2"
      >
        {label}
        {!isValid && <span className="ml-1 text-red-500 font-bold">*</span>}
      </label>
      <div className="mt-1 sm:col-span-2 sm:mt-0">
        <input
          type="text"
          name={name}
          id={htmlId}
          autoComplete="given-name"
          onChange={handleChange}
          value={value}
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-sentinel focus:ring-sentinel sm:text-sm"
        />
      </div>
    </div>
  );
}
